/**
 * クロス設定登録画面 クロスコード取得(リクエストパラメータ)用クラス
 *
 * @export CheckUnselectedGoods
 * @class CheckUnselectedGoods
 */
export class CheckUnselectedGoods {
  /** 受注コード */
  public orderCode = String('');
  /** 媒体区分 */
  public mediumType = String('');
  /** Pコード */
  public pCode = String('');
}
